'use client'
import React, {useContext} from "react"
import Grid from "@mui/material/Grid"
import { Box, useMediaQuery, useTheme } from "@mui/material"

import { TranslationContext } from "@/configs/context"
import VCardCarrousel from "../../components/carousel/VCardCarrousel"


const Hero: React.FC = () => {
  const theme = useTheme()
  // @ts-ignore
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))
  const matchXl = useMediaQuery(theme.breakpoints.up('xl'))

  return (
    <React.Suspense fallback={<div />}>
      <Box
        id="hero-section"
        sx={{
          color: "white",
          pt: { xs: 4, md: 4 },
          pb: { xs: 4, md: 10 },
        }}
      >
        <Grid
          container
          alignItems="center"
          spacing={{ xs: 1, lg: 3 }}
          direction={matchMd ? "row" : "column-reverse"}
          justifyContent={matchXl ? "space-between" : "flex-start"}
        >
          <Grid sx={{ textAlign: "center" }} size={{ xs: 12 }}>
            <VCardCarrousel />
          </Grid>
        </Grid>
      </Box>
    </React.Suspense>
  )
}

export default Hero
